import {
  BlockedSignatureEsignError,
  EsignError,
  InvalidPinEsignError,
} from "@interfaces/Esign";
import { AxiosError } from "axios";

export type ErrorType = {
  error: { name: string; message: string };
  message: string;
};

export const onDocumentSignatureAxiosErrorInterpreter = (
  error: AxiosError<ErrorType>
) => {
  const status = error.response?.status;
  const name = error.response?.data?.error?.name;
  const message = error.response?.data?.message
    ? "[message present]"
    : undefined;
  console.error("Error when signing documents:", { status, name, message });

  if (error.response?.data.error?.name === "InvalidPinEsignError") {
    throw new InvalidPinEsignError(error.response?.data.error?.message ?? "");
  }
  if (error.response?.data.error?.name === "BlockedSignatureEsignError") {
    throw new BlockedSignatureEsignError(
      error.response?.data.error?.message ?? ""
    );
  }
  if (error.response?.data.error?.name === "EsignError") {
    throw new EsignError(error.response?.data.error?.message ?? "");
  }
  throw error;
};
